import {
  LayoutDashboard,
  Link,
  UsersRound,
  UserRoundPen,
  UserRoundCheck,
  Shield,
  UserPlus,
  UserRound,
  UserRoundCog,
  HandCoins,
  ChartCandlestick,
  FileUser,
  Gift,
  UserX,
  SendToBack,
  History,
  Bot,
  Component,
  Waypoints,
} from "lucide-react";

import { UserPermissions } from "@/entities/user";

export type Route = {
  link: string;
  label: string;
  icon: JSX.Element;
};

const homeRoutes: Route[] = [
  {
    label: "Главная",
    link: "/",
    icon: <LayoutDashboard className="stroke-textColor" size={20} />,
  },
];

const botRoutes: Route[] = [
  {
    label: "Мои Боты",
    link: "/bots",
    icon: <Bot className="stroke-textColor" size={20} />,
  },
];

const headNavRoutes: Route[] = [
  {
    label: "Все лиды",
    link: "/head/all-leads",
    icon: <FileUser className="stroke-textColor" size={20} />,
  },
  {
    label: "Профиты",
    link: "/head/profits",
    icon: <ChartCandlestick className="stroke-textColor" size={20} />,
  },
  {
    label: "Доступы",
    link: "/head/access",
    icon: <Shield className="stroke-textColor" size={20} />,
  },
  {
    label: "Мои ссылки",
    link: "/worker/links",
    icon: <UserRound className="stroke-textColor" size={20} />,
  },
  {
    label: "Мои лиды",
    link: "/worker/leads",
    icon: <UserRoundCheck className="stroke-textColor" size={20} />,
  },
  {
    label: "Воркеры",
    link: "/head/workers",
    icon: <UsersRound className="stroke-textColor" size={20} />,
  },
  {
    label: "Менеджеры",
    link: "/teamlead/managers",
    icon: <UserRoundPen className="stroke-textColor" size={20} />,
  },
  {
    label: "Выплаты",
    link: "/head/payouts",
    icon: <HandCoins className="stroke-textColor" size={20} />,
  },
  {
    label: "Кланы",
    link: "/head/clans",
    icon: <Component className="stroke-textColor" size={20} />,
  },
  {
    label: "Модераторы",
    link: "/head/moderators",
    icon: <UserRoundCog className="stroke-textColor" size={20} />,
  },
  {
    label: "Розыгрыши",
    link: "/head/giveaways",
    icon: <Gift className="stroke-textColor" size={20} />,
  },
  {
    label: "Сделки",
    link: "/offers",
    icon: <SendToBack className="stroke-textColor" size={20} />,
  },
  {
    label: "Аналитика",
    link: "/analytics",
    icon: <ChartCandlestick className="stroke-textColor" size={20} />,
  },
  {
    label: "Прокси",
    link: "/proxies",
    icon: <Waypoints className="stroke-textColor" size={20} />,
  },
];

const clanNavRoutes = (
  permissions: UserPermissions[],
  isClanLeader: boolean,
): Route[] => {
  const clanComponent =
    permissions.includes(UserPermissions.CREATE_CLAN) || isClanLeader
      ? {
          label: "Мой клан",
          link: "/clans/my",
          icon: <Component className="stroke-textColor" size={20} />,
        }
      : {
          label: "Кланы",
          link: "/clans",
          icon: <Component className="stroke-textColor" size={20} />,
        };

  return [clanComponent];
};

const workerNavRoutes: Route[] = [
  {
    label: "Лиды",
    link: "/worker/leads",
    icon: <UsersRound className="stroke-textColor" size={20} />,
  },
  {
    label: "Список ссылок",
    link: "/worker/links",
    icon: <Link className="stroke-textColor" size={20} />,
  },
  {
    label: "Сделки",
    link: "/offers",
    icon: <SendToBack className="stroke-textColor" size={20} />,
  },
  {
    label: "История депозитов",
    link: "/deposits-history",
    icon: <History className="stroke-textColor" size={20} />,
  },
  {
    label: "Аналитика",
    link: "/analytics",
    icon: <ChartCandlestick className="stroke-textColor" size={20} />,
  },
];

export const managerNavRoutes: Route[] = [
  {
    label: "Лиды",
    link: "/manager/leads",
    icon: <UserRoundPen className="stroke-textColor" size={20} />,
  },
];

export const teamleadNavRoutes: Route[] = [
  {
    label: "Лиды",
    link: "/teamlead/leads",
    icon: <UserRoundCheck className="stroke-textColor" size={20} />,
  },
  {
    label: "Менеджеры",
    link: "/teamlead/managers",
    icon: <UserRoundPen className="stroke-textColor" size={20} />,
  },
  {
    label: "Доступы",
    link: "/teamlead/access",
    icon: <Shield className="stroke-textColor" size={20} />,
  },
];

const moderatorNavRoutes: Route[] = [
  {
    label: "Заявки",
    link: "/moderator/requests/candidates",
    icon: <UserPlus className="stroke-textColor" size={20} />,
  },
  {
    label: "Неактивные воркеры",
    link: "/moderator/inactive-workers",
    icon: <UserX className="stroke-textColor" size={20} />,
  },
];

const mastersNavRoutes: Route[] = [
  {
    label: "Доступы",
    link: "/master/access",
    icon: <Shield className="stroke-textColor" size={20} />,
  },
];

export const getNavRoutes = (
  role: string,
  permissions: UserPermissions[],
  isClanLeader: boolean,
) => {
  switch (role) {
    case "head":
      return [
        ...homeRoutes,
        ...headNavRoutes,
        ...moderatorNavRoutes,
        ...botRoutes,
      ];
    case "worker":
      return [
        ...homeRoutes,
        ...clanNavRoutes(permissions, isClanLeader),
        ...workerNavRoutes,
        ...botRoutes,
      ];
    case "manager":
      return [...homeRoutes, ...managerNavRoutes];
    case "teamlead":
      return [...homeRoutes, ...teamleadNavRoutes];
    case "master_teamlead":
      return [...homeRoutes, ...teamleadNavRoutes];
    case "moderator":
      return [
        ...homeRoutes,
        ...moderatorNavRoutes,
        ...workerNavRoutes,
        ...botRoutes,
      ];
    case "master_moderator":
      return [
        ...homeRoutes,
        ...moderatorNavRoutes,
        ...workerNavRoutes,
        ...mastersNavRoutes,
        ...botRoutes,
      ];

    default:
      return [];
  }
};
